<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.mdAndDown"
    >
      <v-card>
        <v-card-title>
          <v-col
            cols="5"
            md="5"
          >
            <span class="text-h5">{{ $t("Edit") }}</span>
          </v-col>
          <v-col
            cols="7"
            md="7"
            justify="center"
          >
            <v-switch
              v-model="contentType"
              inset
              class="switch-content-type"
              @click="switchProfile()"
            ></v-switch>
            <span class="text-overline">{{ $t("Personal / Professional") }}</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-stepper
              v-model="step"
              class="custom-header transparent"
              alt-labels
            >
              <v-stepper-header :elevation="6">
                <template>
                  <v-stepper-step
                    :complete="step > 1"
                    :step="1"
                    editable
                    :rules="[() => step1]"
                  >
                    {{ $t("\n                    Description\n                  ") }}
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step
                    :complete="step > 2"
                    :step="2"
                    :editable="checkStep()"
                    :rules="[() => step2]"
                  >
                    {{ $t("\n                    Location\n                  ") }}
                  </v-stepper-step>
                </template>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content
                  :step="1"
                >
                  <v-card
                    color="grey lighten-1 "
                    min-height="500px"
                  >
                    <div class="container">
                      <v-form
                        class="multi-col-validation"
                        style="width: 100%;margin: 0 auto"
                      >
                        <v-row class="d-flex justify-center">
                          <v-col
                            cols="12"
                            md="7"
                            class="position-relative"
                          >
                            <div class="wrapper-slider-book-view">
                              <v-switch
                                v-model="modals.file.view_type"
                                inset
                                class="switch-content-type"
                              ></v-switch>
                              <span class="text-overline">{{ $t("Slider View / Book View") }}</span>
                            </div>
                            <drag-and-drop
                              :related-files="modals.file.related_files"
                              :rotate-position-prop="modals.file.rotate_position"
                              :editing="editing"
                              @filed="fileLoaded"
                              @rotation_position="rotationPosition"
                              @metadata="applyMetadata"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="5"
                            class="entry-description-fields"
                          >
                            <v-row>
                              <v-col
                                class="d-flex"
                                cols="4"
                              >
                                <v-select
                                  v-model="daySelected"
                                  :items="days"
                                  :label="$t(&quot;Day&quot;)"
                                  outlined
                                  dense
                                ></v-select>
                              </v-col>

                              <v-col
                                class="d-flex"
                                cols="4"
                              >
                                <v-select
                                  v-model="monthSelected"
                                  :items="months.map(month => ({ text: $t(month), value: month }))"
                                  :label="$t(&quot;Month&quot;)"
                                  outlined
                                  dense
                                  @change="changeMonth()"
                                ></v-select>
                              </v-col>

                              <v-col
                                class="d-flex"
                                cols="4"
                              >
                                <v-select
                                  v-model="yearSelected"
                                  :items="years"
                                  :label="$t(&quot;Year&quot;)"
                                  outlined
                                  dense
                                  @change="changeYear()"
                                ></v-select>

                                <v-tooltip
                                  top
                                  color="#000000"
                                  max-width="200px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      :class="{'alternate-icon-small': !mdiInformationOutline}"
                                      class="mx-auto icon-info-date"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      {{ mdiInformationOutline }}
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("If you only select the year. The day and month will be set to January 1st.") }}</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>

                            <CustomCategories
                              :manage-categories="false"
                              :content_type="content_type"
                              :categories="categories"
                              :categories-array="modals.file.categories.indexOf(', ') !== -1 ? modals.file.categories.split(', ') : [modals.file.categories]"
                              @getCategories="getCatgContentType"
                              @setCategories="setCategories"
                            />

                            <RecordLanguageEditor
                              ref="languageEditor"
                              :record-id="modals.file.id"
                              :initial-language="$i18n.locale"
                              :name.sync="modals.file.name"
                              :description.sync="modals.file.alternative_text"
                              :original-text.sync="originalText"
                              :disabled="loading || resultUpload"
                              :title-error="titleCheck"
                              :description-error="descriptionCheck"
                              @dirty-change="translationDirtyChanged"
                              @saving-change="translationSaving = $event"
                            />

                            <div class="tag-input">
                              <div
                                v-for="(tag, index) in tags"
                                :key="tag"
                                class="tag-input__tag"
                              >
                                <span @click="removeTag(index)">x</span>
                                {{ tag }}
                              </div>
                              <div class="wrapper-input-icon">
                                <v-text-field
                                  :label="$t(&quot;Enter a tag&quot;)"
                                  outlined
                                  dense
                                  :placeholder="$t(&quot;Enter a tag&quot;)"
                                  hide-details
                                  class="txt-enter-tag"
                                  @keydown.enter="addTag"
                                  @keydown.188="addTag"
                                  @keydown.delete="removeLastTag"
                                ></v-text-field>
                                <v-tooltip
                                  top
                                  color="#000000"
                                  max-width="200px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      dark
                                      :class="{'alternate-icon-small': !mdiInformationOutline}"
                                      class="mx-auto"
                                      :title="$t(&quot;What's a tag?&quot;)"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      {{ mdiInformationOutline }}
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("Tags are used to put additional information to the Main Category selected above and give more details about your image or content. Choose a small number of categories and create your personal tags to fill your content.") }}</span>
                                </v-tooltip>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  :step="2"
                >
                  <v-card
                    color="grey lighten-1"
                  >
                    <v-container
                      v-if="resultUpload"
                      style="height: 400px;"
                    >
                      <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                      >
                        <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                        >
                          {{ $t("\n                          The content has been updated.\n                        ") }}
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container
                      v-if="loading && !resultUpload"
                      style="height: 400px;"
                    >
                      <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                      >
                        <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                        >
                          {{ $t("\n                          Updating your content...\n                        ") }}
                        </v-col>
                        <v-col cols="6">
                          <v-progress-linear
                            color="primary accent-4"
                            indeterminate
                            rounded
                            height="6"
                          ></v-progress-linear>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container v-if="!loading && !resultUpload">
                      <Map
                        v-if="step === 2"
                        :coords="currentLocation"
                        @updateCoordinates="setCoordinates"
                      ></Map>
                    </v-container>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-card-text>
        <div class="px-4 pb-2">
          <v-alert v-if="translationSaveError" dense outlined type="error" role="alert">
            {{ translationSaveError }}
            <v-btn small text :loading="translationRetrying" @click="retryTranslationSave">{{ $t('Retry') }}</v-btn>
          </v-alert>
          <RecordPrivacy
            :record="{ public: modals.file.public, categories: categorySelected }"
            :categories="categories"
            interactive
            :disabled="loading || !!resultUpload"
            @toggle="modals.file.public = $event"
          />
          <RecordTranslation
            v-model="translateOnSave"
            :record="{ public: modals.file.public, categories: categorySelected }"
            :categories="categories"
            :record-id="modals.file.id"
            :saved="resultUpload"
            :disabled="loading || manualTranslationDirty"
            editing
          />
          <span class="text-caption ml-2">{{ $t("Visibility on your public profile") }}</span>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="step !== 2"
            color="primary"
            :disabled="translationSaving"
            @click="nextStep()"
          >
            {{ $t("\n            Continue\n          ") }}
          </v-btn>
          <v-btn
            v-if="step === 2 && !resultUpload && !loading"
            color="success"
            :disabled="translationSaving"
            @click="editFile()"
          >
            {{ $t("\r\n            Update\r\n          ") }}
          </v-btn>
          <v-btn
            v-if="!loading"
            :disabled="translationSaving"
            @click="modalClose(false)"
          >
            {{ $t("\n            Close\n          ") }}
          </v-btn>
        </v-card-actions>
        <v-dialog v-model="discardTranslation" max-width="420">
          <v-card>
            <v-card-title>{{ $t('Unsaved Spanish changes') }}</v-card-title>
            <v-card-text>{{ $t('The Spanish draft has not been saved. Keep editing or discard these changes?') }}</v-card-text>
            <v-card-actions>
              <v-btn text @click="discardTranslation = false">{{ $t('Keep editing') }}</v-btn>
              <v-btn text color="error" @click="$emit('closingModal', true)">{{ $t('Discard changes') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import {
  mdiInformationOutline, mdiCloudUpload, mdiEye, mdiEyeOff,
} from '@mdi/js'
import { uploadMedia } from '@/services/resources'
import DragAndDrop from '@/components/DragAndDrop.vue'
import CustomCategories from '@/components/CustomCategoriesTreeView.vue'
import Map from '@/components/Map_v2.vue'
import RecordLanguageEditor from '@/components/RecordLanguageEditor.vue'

import RecordPrivacy from '../RecordPrivacy.vue'
import RecordTranslation from '../RecordTranslation.vue'

export default {
  components: {
    RecordPrivacy,
    RecordTranslation,
    DragAndDrop,
    CustomCategories,
    Map,
    RecordLanguageEditor,
  },
  props: ['categories', 'categoriesArray', 'modals', 'tagsFull', 'content_type'],
  data() {
    return {
      current_date: this.modals.file.updated_at.split('T')[0].split('-'),
      dayActive: false,
      monthActive: false,
      days: [],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',	'July',	'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      years: [],
      daySelected: null,
      monthSelected: null,
      yearSelected: null,
      location: '',
      selected: {},
      service: null,

      dialog: true,

      /* ICONS */
      mdiInformationOutline,
      mdiCloudUpload,
      mdiEye,
      mdiEyeOff,

      /* CALENDAR */
      menu1: false,
      menu2: false,

      /* -------- */
      /* STEPPERS */
      step1: true,
      step2: true,
      step3: true,
      step: 1,
      steps: 2,

      /* -------- */
      currentLocation: { lat: 0, lng: 0 },

      /* -------- */
      /* FORMs */
      titleCheck: false,
      descriptionCheck: false,
      categoryCheck: false,
      tags: [],
      endpoint: process.env.VUE_APP_ROOT_API,
      fileUploaded: [],
      file: {
        url: '',
      },
      files: [],
      categorySelected: [],
      cmdCategory: [],
      loading: false,
      resultUpload: false,
      translateOnSave: false,
      manualTranslationDirty: false,
      translationSaving: false,
      translationSaveError: '',
      translationRetrying: false,
      discardTranslation: false,
      editing: true,
      contentType: false,
      uploading: false,
      arrayFiles: [],
      rotation_position: [],
      originalText: this.modals.file.original_text || null,
    }
  },
  computed: {
    zoom() {
      return this.modals.zoom
    },
  },
  watch: {
    contentType() {
      this.$emit('getCategories', this.contentType ? 1 : 0)
    },
    steps(val) {
      if (this.step > val) {
        this.step = val
      }
    },
    fileUploaded(val) {
      if (val) {
        this.step1 = true
      }
    },
  },
  mounted() {
    const self = this
    this.currentLocation = JSON.parse(this.modals.file.location)
    this.contentType = !!this.content_type
    this.monthSelected = this.months[parseInt(this.current_date[1], 10) - 1]
    this.generateArrayOfYears()

    if (this.tagsFull) {
      const tags_id = this.modals.file.tags_id ? this.modals.file.tags_id.split(', ') : ''
      this.tagsFull.forEach(elm => {
        if (tags_id.includes(String(elm.id))) {
          self.tags.push(elm.name)
        }
      })
    }
  },
  methods: {
    getCatgContentType(val) {
      this.$emit('getCategories', val)
    },
    changeMonth() {
      this.getDaysInMonthUTC(1, parseInt(this.months.indexOf(this.monthSelected), 10) + 1, this.yearSelected)
    },
    changeYear() {
      this.monthSelected = this.months[0]
      this.getDaysInMonthUTC(1, 0, this.yearSelected)
    },
    getDaysInMonthUTC(day, month, year) {
      this.days = []
      const max = new Date(year, month, 0).getDate()
      for (let i = 1; i <= max; i++) {
        this.days.push(i)
      }
      this.daySelected = day
    },
    generateArrayOfYears() {
      const max = new Date().getFullYear()
      const min = max - 110
      this.years = []

      for (let i = max; i >= min; i--) {
        this.years.push(i)
      }
      this.yearSelected = parseInt(this.current_date[0], 10)
      this.getDaysInMonthUTC(parseInt(this.current_date[2], 10), parseInt(this.current_date[1], 10), this.yearSelected)
    },
    switchProfile() {
      this.categorySelected = []
      this.cmdCategory = []
    },
    setCoordinates(position) {
      this.currentLocation = {
        lat: position.lat,
        lng: position.lng,
      }
    },
    checkStep() {
      return !!(this.step1 && this.fileUploaded)
    },
    translationDirtyChanged(value) {
      this.manualTranslationDirty = value
      if (value) this.translateOnSave = false
    },
    modalClose() {
      if (this.translationSaving) return
      if (this.manualTranslationDirty) this.discardTranslation = true
      else this.$emit('closingModal', true)
    },
    async retryTranslationSave() {
      this.translationRetrying = true
      try { await this.$refs.languageEditor.save(); this.translationSaveError = '' } catch (_) { this.translationSaveError = this.$t('Your memory is saved. The Spanish changes could not be saved. Please retry.') } finally { this.translationRetrying = false }
    },
    nextStep() {
      if (this.translationSaving) return
      if (!this.$refs.languageEditor.prepareSave()) return
      if ((this.step === 1) && (!this.modals.file.name.length || !this.modals.file.alternative_text.length || !this.categorySelected.length)) {
        this.titleCheck = !this.modals.file.name.length
        this.descriptionCheck = !this.modals.file.alternative_text.length
        this.categoryCheck = !this.categorySelected.length
        this.step1 = false
      } else {
        this.step1 = true
        this.step2 = true
        this.step3 = true
        this.step += 1
      }
    },
    setCategories(selected) {
      const self = this
      self.categorySelected = []
      selected.forEach(value => {
        if (!value) return
        if (value.parent_id) {
          if (!self.categorySelected.includes(value.parent_id)) {
            self.categorySelected.push(value.parent_id)
          }
        }
        self.categorySelected.push(value.id)
      })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`
    },
    addTag(event) {
      event.preventDefault()
      const val = event.target.value.trim()
      if (val.length > 0) {
        this.tags.push(val)
        event.target.value = ''
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1)
    },
    removeLastTag(event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1)
      }
    },
    editFile() {
      if (this.translationSaving) return
      if (!this.$refs.languageEditor.prepareSave()) { this.step = 1; return }
      this.loading = true
      axios.post(`${this.endpoint}/updateFileInfos`, {
        name: this.modals.file.name,
        alternative_text: this.modals.file.alternative_text,
        original_text: this.originalText || null,
        category: this.categorySelected,
        tags: this.tags,
        location: this.currentLocation,
        date: `${this.yearSelected}-${String(parseInt(this.months.indexOf(this.monthSelected), 10) + 1).padStart(2, '0')}-${String(this.daySelected).padStart(2, '0')}`,
        content_type: this.contentType,
        file_id: this.modals.file.id,
        public: this.modals.file.public,
        view_type: this.modals.file.view_type,
      }, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(responseDB => {
        this.uploadNewFiles()
      })
    },
    fileLoaded(value) {
      this.fileUploaded = value
    },
    applyMetadata(metadata) {
      if (metadata.date) {
        const d = new Date(metadata.date)
        if (!isNaN(d.getTime())) {
          this.yearSelected = d.getFullYear()
          this.monthSelected = this.months[d.getMonth()]
          this.changeMonth()
          this.daySelected = d.getDate()
        }
      }
      if (metadata.latitude != null && metadata.longitude != null) {
        this.currentLocation = {
          lat: metadata.latitude,
          lng: metadata.longitude,
        }
      }
    },
    rotationPosition(value) {
      this.rotation_position = value
    },
    linkFiles() {
      axios.post(`${this.endpoint}/linkFiles`, {
        files: this.arrayFiles,
        date: `${this.yearSelected}-${String(parseInt(this.months.indexOf(this.monthSelected), 10) + 1).padStart(2, '0')}-${String(this.daySelected).padStart(2, '0')}`,
        file_id: this.modals.file.id,
        rotation_position: this.rotation_position,
      }, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(responseDB => {
        this.finishSave()
        this.fileUploaded = []
      })
    },
    async finishSave() {
      try { await this.$refs.languageEditor.save() } catch (_) { this.translationSaveError = this.$t('Your memory is saved. The Spanish changes could not be saved. Please retry.') }
      this.loading = false
      this.resultUpload = true
    },
    formatString(str) {
      return str.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
    },
    getExtFromMime(mimeType) {
      if (!mimeType) return ''
      const map = {
        'image/jpeg': '.jpg',
        'image/png': '.png',
        'image/gif': '.gif',
        'image/webp': '.webp',
        'image/bmp': '.bmp',
        'image/svg+xml': '.svg',
        'image/tiff': '.tiff',
        'image/heic': '.heic',
        'video/mp4': '.mp4',
        'video/webm': '.webm',
        'video/ogg': '.ogg',
        'video/quicktime': '.mov',
        'video/x-msvideo': '.avi',
        'video/x-matroska': '.mkv',
      }

      return map[mimeType] || ''
    },
    async uploadNewFiles() {
      this.uploading = true
      const keys = []
      try {
        for (const elm of this.fileUploaded) {
          if (typeof elm === 'string') {
            keys.push(elm.includes('amazonaws.com/') ? decodeURIComponent(elm.split('amazonaws.com/')[1].split('?')[0]) : elm)
          } else {
            // Sequential uploads stop at the first limit; successful files are reused on retry.
            // eslint-disable-next-line no-await-in-loop
            const response = await uploadMedia({
              buffer: elm.file,
              originalname: this.formatString(this.modals.file.name.toLowerCase().trim().replace(/\s+/g, '-')) + this.getExtFromMime(elm.mimeType),
              mime: elm.mimeType,
            }, elm)
            keys.push(response.data.Data.Key)
          }
        }
        this.arrayFiles = keys
        this.linkFiles()
      } catch (_) { this.uploading = false }
    },
  },
}
</script>

<style scoped lang="scss">
.v-input__control > .v-input__slot {
  min-height: 41px;
}

.v-select.v-input--dense .v-chip {
  margin-top: 4px;
}

.v-text-field.v-input--dense {
  padding-top: 0;
  display: block;
  margin-bottom: 10px !important;
}

.tag-input {
  width: 100%;
  border: 1px solid #eee;
  font-size: 0.9em;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 1rem;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin-bottom: 16px;
  font-size: 14px;
  padding-top: 10px;
  min-height: 124px;

  &__tag {
    height: 30px;
    float: left;
    margin-right: 10px;
    background-color: #eee;
    margin-bottom: 10px;
    line-height: 27px;
    padding: 0 8px;
    border-radius: 5px;
  }

  &__tag > span {
    cursor: pointer;
    color:#8898aa;
    opacity: 0.75;
  }

  &__text {
    color:#40474e;
    border: none;
    outline: none;
    font-size: 0.9em;
    line-height: 50px;
    background: none;
    width: 100%;
  }
}

.wrapper-input-icon {
  position: relative;
  width: 100%;
  clear: both;
  .v-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2%;
  }
  .v-icon__svg {
    fill: gray;
  }
}

.img-edit {
  height: auto;
  border-radius: 12px;
  max-height: 92%;
  width: auto;
  margin: 0 auto;
  display: block;
  max-width: 100%;
}
.v-input--selection-controls {
  margin-top: 0;
}
.places-dropdown {
  position: absolute;
  top: 55px;
  z-index: 1;
  background: #fff;
  width: 100%;
  max-width: 428px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 3px rgb(0 0 0 / 40%);
  list-style: none;
  max-height: 354px;
  overflow-y: auto;

  li {
    padding: 8px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    &:last-child {
      border: 0;
    }
  }
}
.switch-content-type {
  width: 40px;
  height: 30px;
  margin-left: 10.5%;
}

.icon-info-date {
  position: relative;
  top: -5px;
  left: 5px;
}

.v-stepper__header {
  margin-bottom: 20px;
}

.v-stepper__content {
  .v-stepper__wrapper {
    overflow: unset;
    .v-card {
      box-shadow: none !important;
    }
  }
}

.v-stepper__items {
  overflow: unset !important;

}

@media (min-width: 960px) {
  .entry-description-fields {
    position: relative;
    top: -55px;
  }
}

.btn-privacy {
  position: relative;
  left: 10px;
}

.wrapper-slider-book-view {
  position: absolute;
  top: -63px;
  left: 50%;
  transform: translateX(-50%);

  .switch-content-type {
    margin-left: 42%;
  }
}
</style>
